/**
 * @generated SignedSource<<03e97238645dbe4ef6d2bee8c5e13f6f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PipelinesBreadcrumbsQuery$variables = {
  fetchPipeline: boolean;
  fetchPipelineRun: boolean;
  pipelineLocator: string;
  pipelineRunLocator: string;
};
export type PipelinesBreadcrumbsQuery$data = {
  readonly build?: {
    readonly " $fragmentSpreads": FragmentRefs<"PipelinesBreadcrumbsRunFragment">;
  } | null | undefined;
  readonly pipeline?: {
    readonly " $fragmentSpreads": FragmentRefs<"PipelinesBreadcrumbsPipelineFragment">;
  } | null | undefined;
};
export type PipelinesBreadcrumbsQuery = {
  response: PipelinesBreadcrumbsQuery$data;
  variables: PipelinesBreadcrumbsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchPipeline"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchPipelineRun"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pipelineLocator"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pipelineRunLocator"
},
v4 = [
  {
    "kind": "Variable",
    "name": "pipelineLocator",
    "variableName": "pipelineLocator"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "buildLocator",
    "variableName": "pipelineRunLocator"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelinesBreadcrumbsQuery",
    "selections": [
      {
        "condition": "fetchPipeline",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v4/*:: as any*/),
            "concreteType": "PipelineRest",
            "kind": "LinkedField",
            "name": "pipeline",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PipelinesBreadcrumbsPipelineFragment"
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "fetchPipelineRun",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v5/*:: as any*/),
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "build",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PipelinesBreadcrumbsRunFragment"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "PipelinesBreadcrumbsQuery",
    "selections": [
      {
        "condition": "fetchPipeline",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v4/*:: as any*/),
            "concreteType": "PipelineRest",
            "kind": "LinkedField",
            "name": "pipeline",
            "plural": false,
            "selections": [
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectRest",
                "kind": "LinkedField",
                "name": "parentProject",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Projects",
                    "kind": "LinkedField",
                    "name": "ancestorProjects",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectRest",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": true,
                        "selections": [
                          (v6/*:: as any*/),
                          (v7/*:: as any*/),
                          (v8/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              },
              (v8/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "fetchPipelineRun",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v5/*:: as any*/),
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "build",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "canceledInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "failedToStart",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "personal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "detachedFromAgent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "number",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "queuePosition",
                "storageKey": null
              },
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BuildTypeRest",
                "kind": "LinkedField",
                "name": "buildType",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "internalId",
                    "storageKey": null
                  },
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              (v8/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "891b871bed85532e47a838e0d8c9e953",
    "id": null,
    "metadata": {},
    "name": "PipelinesBreadcrumbsQuery",
    "operationKind": "query",
    "text": "query PipelinesBreadcrumbsQuery(\n  $pipelineLocator: String!\n  $pipelineRunLocator: String!\n  $fetchPipeline: Boolean!\n  $fetchPipelineRun: Boolean!\n) {\n  pipeline(pipelineLocator: $pipelineLocator) @include(if: $fetchPipeline) {\n    ...PipelinesBreadcrumbsPipelineFragment\n    _id\n  }\n  build(buildLocator: $pipelineRunLocator) @include(if: $fetchPipelineRun) {\n    ...PipelinesBreadcrumbsRunFragment\n    _id\n  }\n}\n\nfragment PipelinesBreadcrumbsPipelineFragment on PipelineRest {\n  id\n  name\n  parentProject {\n    id\n    name\n    ancestorProjects {\n      project {\n        id\n        name\n        _id\n      }\n    }\n    _id\n  }\n}\n\nfragment PipelinesBreadcrumbsRunFragment on Build {\n  ...useBuildStatusIconFragment\n  ...useFormatBuildNumberFragment\n  ...useRunningBuildUpdaterRelayFragment\n  state\n  startDate\n}\n\nfragment useBuildStatusIconFragment on Build {\n  status\n  state\n  canceledInfo {\n    __typename\n  }\n  failedToStart\n  personal\n  detachedFromAgent\n  user {\n    id\n    _id\n  }\n}\n\nfragment useFormatBuildNumberFragment on Build {\n  number\n  state\n  queuePosition\n}\n\nfragment useRunningBuildUpdaterRelayFragment on Build {\n  id\n  state\n  buildType {\n    internalId\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb4ee982ac320abaf12de5eac9d4774b";

export default node;
